export default {
    install(Vue) {
        return Vue.prototype.$errors = (error) => {
            return Object.fromEntries(
                Object.entries(error.errors || error || []).map(([key, value]) => [key, value[0]])
            )
        }
    }
}
